import { Injectable } from '@angular/core';
@Injectable()
export class Square {
    constructor(private ctx: CanvasRenderingContext2D) { }

    draw(x: number, y: number, z: number) {
        this.ctx.fillRect(z * x, z * y, z, z);
    }
}